export const PosthogEventKeys = {
  LOGIN: 'user_login',
  SIGNUP: 'user_signup',
  LOGOUT: 'user_logout',
  PAGE_VIEW: 'page_view',

  // User Journey Events
  API_KEY_ADDED: 'api_key_added',
  KEYWORD_ADDED_TO_LIST: 'keyword_added_to_list',
  // ! deprecated, use PROJECT_ADDED_TO_RANK_TRACKER instead
  DOMAIN_ADDED_TO_RANK_TRACKER: 'domain_added_to_rank_tracker',
  PROJECT_ADDED_TO_RANK_TRACKER: 'project_added_to_rank_tracker',
  KEYWORD_ADDED_TO_RANK_TRACKER: 'keyword_added_to_rank_tracker',
  KEYWORD_SEARCHED: 'keyword_searched',

  // OnClick useAction() Events
  ONBOARDING_COMPLETED: 'onboarding_completed',
  SETTINGS_UPDATED: 'user_settings_updated',
  ARTICLE_DUPLICATED: 'article_duplicated',
  ARTICLES_DELETED: 'articles_deleted',
  ARTICLE_CREATED: 'article_created',
  CHAT_PROMPT_PRESET_CREATED: 'chat_prompt_preset_created',
  SEND_CHAT_MESSAGE: 'send_chat_message',
  ARTICLE_UPDATED: 'article_updated',
  CONTENT_REPLACER_PRESET_CREATED: 'content_replacer_preset_created',
  CONTENT_REPLACER_PRESET_DELETED: 'content_replacer_preset_deleted',
  HEADING_PRESET_CREATED: 'heading_preset_created',
  HEADING_PRESET_DELETED: 'heading_preset_deleted',
  MASTER_PRESET_CREATED: 'master_preset_created',
  MASTER_PRESET_UPDATED: 'master_preset_updated',
  MASTER_PRESET_DELETED: 'master_preset_deleted',
  PROMPT_CONFIG_PRESET_CREATED: 'prompt_config_preset_created',
  SECTION_PROMPT_PRESET_CREATED: 'section_prompt_preset_created',
  KEYWORD_DATA_FETCHED: 'keyword_data_fetched',
  GSC_ACCOUNT_DELETED: 'gsc_account_deleted',
  GSC_SEARCH_COMPLETED: 'gsc_search_completed',
  GSC_FILTER_PRESET_CREATED: 'gsc_filter_preset_created',
  GSC_FILTER_PRESET_DELETED: 'gsc_filter_preset_deleted',
  GSC_SITE_DELETED: 'gsc_site_deleted',
  GSC_SITES_IMPORTED: 'gsc_sites_imported',
  LIST_CREATED: 'list_created',
  LIST_MERGED: 'list_merged',
  KEYWORD_DELETED: 'keyword_deleted',
  LIST_DELETED: 'list_deleted',
  KEYWORD_UPDATED: 'keyword_updated',
  KEYWORD_MOVED: 'keyword_moved',
  KEYWORD_SAVED: 'keyword_saved',
  DOMAIN_ADDED: 'domain_added',
  DOMAIN_UPDATED: 'domain_updated',
  DOMAIN_RANKED_KEYWORDS_REFRESHED: 'domain_ranked_keywords_refreshed',
  DOMAIN_DELETED: 'domain_deleted',
  KEYWORD_ADDED: 'keyword_added',
  KEYWORD_REFRESHED: 'keyword_refreshed',
  SEARCH_RANKED_KEYWORDS_FOR_DOMAIN: 'search_ranked_keywords_for_domain',
  KEYWORD_COMPARED: 'keyword_compared',
  ARTICLE_REFETCHED: 'article_refetched',
  GSC_SITE_REFRESHED: 'gsc_site_refreshed',
  ARTICLE_GENERATED: 'article_generated',
  KEYWORD_SCORE_FETCHED_BY_OPERATOR: 'keyword_score_fetched_by_operator',
  QUICK_DIFFICULTY_SCORE_FETCHED_BY_OPERATOR:
    'quick_difficulty_score_fetched_by_operator',
  KEYWORD_BULK_REFRESHED: 'rank tracker keyword_bulk_refreshed',
  ARTICLE_BULK_GENERATED: 'article_bulk_generated',
  COPY_REFERRAL_LINK: 'copy_referral_link',
  COPY_REFERRAL_MESSAGE: 'copy_referral_message',
  CLAIM_ACTION: 'claim_action',
} as const;
